import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-136fbd54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-col flex-no-wrap h-100 overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Video")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OnDemandBookingTelehealthWaitingRoomOverlay = _resolveComponent("OnDemandBookingTelehealthWaitingRoomOverlay")!
  const _component_app_chip = _resolveComponent("app-chip")!
  const _component_PatientTelehealthHeader = _resolveComponent("PatientTelehealthHeader")!
  const _component_ChatView = _resolveComponent("ChatView")!
  const _component_VideoViewForIonSlides = _resolveComponent("VideoViewForIonSlides")!
  const _component_TelehealthWrapper = _resolveComponent("TelehealthWrapper")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (!_ctx.leavingPage)
    ? (_openBlock(), _createBlock(_component_ion_page, { key: 0 }, {
        default: _withCtx(() => [
          (!_ctx.inRoom())
            ? (_openBlock(), _createBlock(_component_OnDemandBookingTelehealthWaitingRoomOverlay, {
                key: 0,
                class: "overlay-content-wrapper",
                onExit: _ctx.onExit,
                isLoading: !_ctx.callOver,
                failure: null,
                "clinic-id": _ctx.clinicId,
                "queued-appointment-id": _ctx.queuedAppointmentId,
                "queue-id": _ctx.queueId
              }, null, 8, ["onExit", "isLoading", "clinic-id", "queued-appointment-id", "queue-id"]))
            : _createCommentVNode("", true),
          _createVNode(_component_TelehealthWrapper, {
            "chat-visible": _ctx.chatVisible,
            "content-id": "video-view"
          }, {
            menu: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_PatientTelehealthHeader, { onExit: _ctx.onExit }, {
                  default: _withCtx(() => [
                    (_ctx.inRoom())
                      ? (_openBlock(), _createBlock(_component_app_chip, {
                          key: 0,
                          id: "chat-toggle",
                          onClick: _ctx.toggleChat
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onExit"]),
                _createVNode(_component_ChatView, {
                  class: "flex-item-grow m-l-16 m-r-16",
                  onSend: _ctx.sendTextMessage,
                  onInput: _ctx.singleTyping,
                  typing: _ctx.showTypingIndication,
                  "chat-items": _ctx.chatItems,
                  disabled: !_ctx.remoteConnected()
                }, null, 8, ["onSend", "onInput", "typing", "chat-items", "disabled"])
              ])
            ]),
            content: _withCtx(() => [
              _createVNode(_component_VideoViewForIonSlides, {
                onCall: _ctx.enterRoom,
                onEnd: _ctx.endCall,
                onFlip: _ctx.cycleCamera,
                onToggleVideo: _ctx.toggleVideo,
                onMute: _ctx.toggleMute,
                onChat: _ctx.toggleChat,
                state: _ctx.videoControlState
              }, null, 8, ["onCall", "onEnd", "onFlip", "onToggleVideo", "onMute", "onChat", "state"])
            ]),
            _: 1
          }, 8, ["chat-visible"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}